import { ReactElement } from 'react'
import { GetStaticPropsContext } from 'next'

import Meta from '@/components/base/Meta'
import Footer from '@/components/layout/InlineFooter'
import Layout from '@/components/layout/Layout'
import { getPromiseFromFetch } from '@/utils/request'
import { MOCK_DATA } from '@/constants'

import { WPPageData } from '@/types'

export default function Home() {
  return null
}

Home.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout>
      <Meta pageProps={pageProps} />
      {page}
      <Footer />
    </Layout>
  )
}

export async function getStaticProps(
  // eslint-disable-next-line no-unused-vars
  props: GetStaticPropsContext<{ routes: string[] }>
) {
  const { data: pageProps } = MOCK_DATA
    ? { data: require(`@/data/pages/home.json`) }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: `/`
      })

  return {
    props: {
      ...pageProps
    }
  }
}
